import OtpBackArrow from '@assets/svgs/auth/otp-back-arrow.svg';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

/**
 * BackButton component
 *
 * @param {Object} props
 * @param {boolean} [props.disabled] - When true, the button is non-clickable and uses default cursor.
 * @param {Function} props.handelClick - Callback fired when the button is clicked (ignored when disabled).
 * @param {string} [props.text] - Custom label for the button; defaults to translated "Back" when omitted.
 * @returns {React.ReactElement}
 */
const BackButton = ({ disabled, handelClick, text }) => {
  const { t } = useTranslation('common');
  return (
    <div
      css={[
        tw`font-['Inter'] gap-[0.375rem] text-[0.9rem] font-[600] flex items-center text-info cursor-pointer w-fit`,
        disabled && tw`cursor-default`,
      ]}
      onClick={disabled ? undefined : handelClick}
    >
      <img loading="lazy" decoding="async" tw="w-[1rem] h-[1rem]" src={OtpBackArrow} alt="otp-back" />
      {text || 'Back'}
    </div>
  );
};

export default BackButton;
